import type { IconData } from '@stacksjs/iconify-core'

export const petPaw: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M24 20c-6.334 0-11.686 5.531-13.414 12.635c-.76 3.124.386 6.44 3.199 7.998C16.015 41.868 19.332 43 24 43s7.986-1.132 10.216-2.367c2.813-1.558 3.958-4.874 3.198-7.998C35.686 25.53 30.334 20 24 20M3 18.444C3 21.206 4.79 24 7 24s4-2.794 4-5.556S9.21 14 7 14s-4 1.683-4 4.444m42 0C45 21.206 43.21 24 41 24s-4-2.794-4-5.556S38.79 14 41 14s4 1.683 4 4.444m-31.5-9c0 2.762 1.79 5.556 4 5.556s4-2.794 4-5.556S19.71 5 17.5 5s-4 1.683-4 4.444m21 0c0 2.762-1.79 5.556-4 5.556s-4-2.794-4-5.556S28.29 5 30.5 5s4 1.683 4 4.444\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default petPaw
